import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { getFirestore, doc, getDoc, collection, query, where, getDocs } from 'firebase/firestore';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Row, Col, Card, Table, Modal, Button } from 'react-bootstrap'; // Importa Modal y Button

const UserProfile = () => {
  const { user } = useAuth();
  const [userInfo, setUserInfo] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false); // Estado para el modal
  const [modalContent, setModalContent] = useState(''); // Contenido del modal (enlace al comprobante)
  const db = getFirestore();

  useEffect(() => {
    AOS.init({ duration: 1000 });

    const fetchUserInfo = async () => {
      if (user) {
        try {
          const userRef = doc(db, 'users', user.uid);
          const userDoc = await getDoc(userRef);
          if (userDoc.exists()) {
            setUserInfo(userDoc.data());
          } else {
            setError('No se encontró información del usuario.');
          }
        } catch (err) {
          setError('Error al obtener la información del usuario.');
        }
      } else {
        setError('No hay usuario autenticado.');
      }
    };

    const fetchTransactions = async () => {
      if (user) {
        try {
          const q = query(collection(db, 'payments'), where('userId', '==', user.uid));
          const querySnapshot = await getDocs(q);
          const transactionsList = querySnapshot.docs.map(doc => doc.data());
          setTransactions(transactionsList);
        } catch (err) {
          setError('Error al obtener las transacciones.');
        }
      }
    };

    if (user) {
      fetchUserInfo();
      fetchTransactions();
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, [user, db]);

  const handleShowModal = (receiptUrl) => {
    setModalContent(receiptUrl); // Establece el URL del comprobante
    setShowModal(true); // Muestra el modal
  };

  const handleCloseModal = () => {
    setShowModal(false); // Cierra el modal
  };

  if (loading) {
    return <div>Cargando...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <>
      <Header />
      <section className="hero-section" id="hero-profile">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8" data-aos="fade-right">
              <h1>Perfil de {user?.displayName || user?.email || 'Usuario'}</h1>
              <p className="mb-4">
                Aquí puedes ver y editar tu información personal y las operaciones realizadas.
              </p>
            </div>
            <div className="col-lg-4" data-aos="fade-left">
              <img src="/assets/img/profile.png" alt="Perfil" className="img-fluid" />
            </div>
          </div>
        </div>
      </section>
      <main id="main">
        <section className="section">
          <div className="container">
            <Row>
              <Col md={12}>
                <Card>
                  <Card.Body>
                    <Card.Title>Operaciones Realizadas</Card.Title>
                    {transactions.length > 0 ? (
                      <div className="table-responsive my-3">
                        <Table responsive striped bordered hover size="sm" className="align-middle text-center">
                          <thead className="table-dark">
                            <tr>
                              <th>Fecha</th>
                              <th>Enviado</th>
                              <th>Recibido</th>
                              <th>Remitente</th>
                              <th>Receptor</th>
                              <th>Comprobante</th>
                            </tr>
                          </thead>
                          <tbody>
                            {transactions.map(tx => {
                              const statusClass =
                                tx.status === 'En revisión' ? 'table-warning' :
                                tx.status === 'Rechazado'    ? 'table-danger'  :
                                tx.status === 'Validado'     ? 'table-success' : '';
                              return (
                                <tr key={tx.createdAt + tx.sendAmount} className={statusClass}>
                                  <td>{new Date(tx.createdAt).toLocaleDateString()}</td>
                                  <td>{tx.sendAmount} {tx.origen}</td>
                                  <td>{tx.receiveAmount} {tx.destino}</td>
                                  <td>{tx.sender.fullName || `${tx.sender.firstName} ${tx.sender.lastName}`}</td>
                                  <td>{`${tx.receiver.firstName} ${tx.receiver.lastName}`}</td>
                                  <td>
                                    {tx.paymentReceipt ? (
                                      <Button size="sm" variant="primary" onClick={() => handleShowModal(tx.paymentReceipt)}>
                                        Ver comprobante
                                      </Button>
                                    ) : 'N/A'}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    ) : (
                      <p>No se encontraron operaciones.</p>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
        </section>
      </main>

      {/* Modal para mostrar el comprobante de pago */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Comprobante de Pago</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <iframe src={modalContent} style={{ width: '100%', height: '500px' }} frameBorder="0"></iframe>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      <Footer />
    </>
  );
};

export default UserProfile;
